// extracted by mini-css-extract-plugin
export default {"iconContainer":"ServiceCatalogItem_iconContainer__KVlNb","imageContainer":"ServiceCatalogItem_imageContainer__VHtJE"};